import cn from 'classnames';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import ImageViewer from 'react-simple-image-viewer';
import { Column, Row } from '../../../../components/Basic/Blocks';
import { Input } from '../../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableCell, TableHeader, TableLine } from '../../../../components/Basic/Table';
import { H2, Text, TextGrey } from '../../../../components/Basic/WrapsStyle';
import ProviderList from '../../../../components/Common/Input/ProviderList';
import CommissionNdsBlock from '../../../../components/Markets/Blocks/CommissionNdsBlock';
import { formFullDate, numberWithSpaces } from '../../../../utils';
import { WIDTH_OZON_ORDERS } from '../index';
import styles from '../styles.module.scss';

const OzonTableOrders = ({
  shop,
  calculation = {},
  isOwner = true,
  isExpress = false,
  groups = {},
  select,
  map,
  skladName,
  onChange = () => { },
}) => {

  console.log(skladName)
  const user = useSelector((store) => store.user);

  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [images, setImages] = useState([]);

  const openImageViewer = (imgs) => {
    setImages(imgs);
    setIsViewerOpen(true);
  };
  const closeImageViewer = () => {
    setIsViewerOpen(false);
    setImages([]);
  };


  return (
    <>
      <Table styles={styles.ozon_table}>
        <TableHeader whiteHeader={true} styles={styles.table_line}>
          <HeaderTitle width={WIDTH_OZON_ORDERS[3]} centerText>Площадка</HeaderTitle>
          <HeaderTitle width={WIDTH_OZON_ORDERS[0]}>Номер заказа</HeaderTitle>
          <HeaderTitle width={WIDTH_OZON_ORDERS[1]}>Позиции в заказе</HeaderTitle>
          <HeaderTitle width={WIDTH_OZON_ORDERS[2]}>Артикул товара</HeaderTitle>
          <HeaderTitle width={WIDTH_OZON_ORDERS[3]} centerText>
            Цена продажи
          </HeaderTitle>
          {isOwner && (
            <HeaderTitle width={WIDTH_OZON_ORDERS[3]} centerText>
              Цена закупки
            </HeaderTitle>
          )}
          <HeaderTitle width={WIDTH_OZON_ORDERS[4]} centerText>
            Прибыль/комиссия
          </HeaderTitle>

          <HeaderTitle width={WIDTH_OZON_ORDERS[5]} centerText>
            Поставщик
          </HeaderTitle>
          <HeaderTitle width={WIDTH_OZON_ORDERS[6]} centerText>
            Артикул поставщика
          </HeaderTitle>
          <HeaderTitle width={WIDTH_OZON_ORDERS[6]} centerText>
            Количество в заказе
          </HeaderTitle>
          <HeaderTitle width={WIDTH_OZON_ORDERS[7]} centerText>
            Цена
          </HeaderTitle>
          <HeaderTitle width={WIDTH_OZON_ORDERS[7]} centerText>
            Остаток
          </HeaderTitle>
          <HeaderTitle width={WIDTH_OZON_ORDERS[7]} centerText>
            Остаток на складе
          </HeaderTitle>
          <HeaderTitle width={WIDTH_OZON_ORDERS[7]} centerText />
          <HeaderTitle width={WIDTH_OZON_ORDERS[7]} centerText>
            Длина, мм
          </HeaderTitle>
          <HeaderTitle width={WIDTH_OZON_ORDERS[7]} centerText>
            Высота, мм
          </HeaderTitle>
          <HeaderTitle width={WIDTH_OZON_ORDERS[7]} centerText>
            Ширина, мм
          </HeaderTitle>
          <HeaderTitle width={WIDTH_OZON_ORDERS[7]} centerText>
            Объем, л
          </HeaderTitle>
          <HeaderTitle width={WIDTH_OZON_ORDERS[7]} centerText />
        </TableHeader>
        {(groups[select] || []).map((order) => {
          const mapByShop = map[order.shop]
          console.log(mapByShop)

          return (
            <TableLine key={order.posting_number}>
              <TableCell width={WIDTH_OZON_ORDERS[3]}>
                <Column style={{ alignItems: 'center' }}>
                  {order.shop}
                </Column>
              </TableCell>
              <TableCell width={WIDTH_OZON_ORDERS[0]} minWidth={WIDTH_OZON_ORDERS[0]}>
                {order.posting_number} <TextGrey fontSize={14}>{formFullDate(order.in_process_at)}</TextGrey>
              </TableCell>
              <TableCell width={WIDTH_OZON_ORDERS[1]}>
                <Column>
                  {order.products.map((p, k) => {


                    const data = mapByShop[p.offer_id] || { loaded: false };
                    const img = !!mapByShop[p.offer_id] ? data.images || [] : [];

                    return (
                      <div key={k} className={styles.div_line_images}>
                        <div className={styles.wrapper}>
                          <img
                            onClick={() => openImageViewer([img[0]])}
                            className={styles.preview}
                            src={img.length > 0 ? img[0] : undefined}
                          />
                        </div>
                        <div className={styles.name}>{`${p.quantity} x ${p.name}`}</div>
                      </div>
                    );
                  })}
                </Column>
              </TableCell>
              <TableCell width={WIDTH_OZON_ORDERS[2]}>
                <Column>
                  {order.products.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={`${p.offer_id}${k}`} className={styles.div_line}>
                      <Text className={!!mapByShop[p.offer_id] ? styles.green_text : styles.red_text}>{p.offer_id}</Text>
                    </div>
                  ))}
                </Column>
              </TableCell>
              <TableCell width={WIDTH_OZON_ORDERS[3]}>
                <Column style={{ alignItems: 'center' }}>
                  {order.products.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={k} className={styles.div_line}>
                      {Math.ceil(p.price.amount)}
                    </div>
                  ))}
                </Column>
              </TableCell>
              {isOwner && (
                <TableCell width={WIDTH_OZON_ORDERS[3]}>
                  <Column>
                    {order.products.map((p, k) => (
                      // eslint-disable-next-line react/no-array-index-key
                      <div key={k} className={styles.div_line}>
                        <Input
                          value={(mapByShop[p.offer_id] || {}).purchase}
                          onBlur={(v) => onChange(p.offer_id, order.shop, 'purchase', v)}
                          center
                        />
                      </div>
                    ))}
                  </Column>
                </TableCell>
              )}
              <TableCell width={WIDTH_OZON_ORDERS[4]}>
                {isOwner ? (
                  <Column>
                    {order.products.map((p, k) => {
                      const data = mapByShop[p.offer_id] || {};
                      const profit = p.profit;
                      return (
                        <div key={k} className={styles.div_commission}>
                          {profit && (
                            <>
                              <Text className={styles.block_mar}>{profit.percent} %</Text>
                              <div className={styles.block_commission}>
                                <Text className={profit.is_minus ? styles.red_text : styles.green_text}>
                                  {numberWithSpaces(profit.rub)}
                                </Text>
                                <CommissionNdsBlock
                                  card={{ ...data, profit, commission: p.commission }}
                                  isExpress={isExpress}
                                  market={'OZON'}
                                />
                              </div>
                            </>
                          )}
                        </div>
                      );
                    })}
                  </Column>
                ) : (
                  <Column>
                    {order.products.map((p, k) => {
                      const data = mapByShop[p.offer_id] || {};
                      const profit = data.profit;
                      return (
                        <>
                          {!!mapByShop[p.offer_id] && (
                            <Text
                              className={profit.is_minus ? styles.red_text : styles.green_text}
                              style={{ textAlign: 'center' }}
                            >
                              {profit < 0 ? `В минус на ${profit.rub}` : 'ок'}
                            </Text>
                          )}
                        </>
                      );
                    })}
                  </Column>
                )}
              </TableCell>
              <TableCell width={WIDTH_OZON_ORDERS[5]}>
                <Column style={{ alignItems: 'center' }}>
                  {order.products.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={k} className={styles.div_line}>
                      <ProviderList
                        selectProviderId={(mapByShop[p.offer_id] || {}).provider_id}
                        onSelect={(v) => onChange(p.offer_id, order.shop, 'provider_id', v.id)}
                      />
                    </div>
                  ))}
                </Column>
              </TableCell>
              <TableCell width={WIDTH_OZON_ORDERS[6]}>
                <Column>
                  {order.products.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={k} className={styles.div_line}>
                      <Input
                        value={(mapByShop[p.offer_id] || {}).provider_artnumber}
                        onBlur={(v) => onChange(p.offer_id, order.shop, 'provider_artnumber', v)}
                        center
                      />
                    </div>
                  ))}
                </Column>
              </TableCell>

              <TableCell width={WIDTH_OZON_ORDERS[6]}>
                <Column>
                  {order.products.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={k} className={styles.div_line}>
                      <Input
                        value={(mapByShop[p.offer_id] || {}).quantity}
                        onBlur={(v) => onChange(p.offer_id, order.shop, 'quantity', v)}
                        center
                      />
                    </div>
                  ))}
                </Column>
              </TableCell>
              <TableCell width={WIDTH_OZON_ORDERS[7]}>
                <Column>
                  {order.products.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={k} className={styles.div_line}>
                      <Input
                        value={(mapByShop[p.offer_id] || {}).prices?.price}
                        onBlur={(v) => onChange(p.offer_id, order.shop, 'price', v)}
                        center
                      />
                    </div>
                  ))}
                </Column>
              </TableCell>
              <TableCell width={WIDTH_OZON_ORDERS[7]}>
                <Column>
                  {order.products.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={k} className={styles.div_line}>
                      <Input
                        value={(mapByShop[p.offer_id] || {}).stock?.[skladName]?.common}
                        onBlur={(v) => onChange(p.offer_id, order.shop, 'stock', v)}
                        center
                      />
                    </div>
                  ))}
                </Column>
              </TableCell>
              <TableCell width={WIDTH_OZON_ORDERS[7]}>
                <Column>
                  {order.products.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={k} className={styles.div_line}>
                      <Input
                        value={(mapByShop[p.offer_id] || {}).stock?.[skladName]?.warehouse}
                        center
                        readOnly
                      />
                    </div>
                  ))}
                </Column>
              </TableCell>
              <TableCell width={WIDTH_OZON_ORDERS[7]}>
                <Column>
                  {order.products.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <Row key={k} className={styles.div_line}>
                      {mapByShop[p.offer_id]?.prices?.price != parseFloat(p.price.amount) && (
                        <div className={cn(styles.sale)}>Акция</div>
                      )}
                      {(mapByShop[p.offer_id] || { stocks_warehouse: 0 }).stocks_warehouse > 0 && (
                        <div
                          className={cn(
                            styles.warehouse_block,
                            (mapByShop[p.offer_id] || { stocks_warehouse: 0 }).stocks_warehouse ===
                            (mapByShop[p.offer_id] || {}).stocks && styles.only_warehouse,
                          )}
                        >
                          Склад
                        </div>
                      )}
                    </Row>
                  ))}
                </Column>
              </TableCell>
              <TableCell width={WIDTH_OZON_ORDERS[7]}>
                <Column>
                  {order.products.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <Row key={k} className={styles.div_line}>
                      <Input
                        value={((mapByShop[p.offer_id] || { sizes_package: {} }).sizes_package || {}).depth}
                        onBlur={(v) => onChange(p.offer_id, order.shop, 'depth', v)}
                        center
                      />
                    </Row>
                  ))}
                </Column>
              </TableCell>
              <TableCell width={WIDTH_OZON_ORDERS[7]}>
                <Column>
                  {order.products.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <Row key={k} className={styles.div_line}>
                      <Input
                        value={((mapByShop[p.offer_id] || { sizes_package: {} }).sizes_package || {}).height}
                        onBlur={(v) => onChange(p.offer_id, order.shop, 'height', v)}
                        center
                      />
                    </Row>
                  ))}
                </Column>
              </TableCell>
              <TableCell width={WIDTH_OZON_ORDERS[7]}>
                <Column>
                  {order.products.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <Row key={k} className={styles.div_line}>
                      <Input
                        value={((mapByShop[p.offer_id] || { sizes_package: {} }).sizes_package || {}).width}
                        onBlur={(v) => onChange(p.offer_id, order.shop, 'width', v)}
                        center
                      />
                    </Row>
                  ))}
                </Column>
              </TableCell>
              <TableCell width={WIDTH_OZON_ORDERS[7]}>
                <Column>
                  {order.products.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <Row key={k} className={styles.div_line}>
                      <Input
                        value={((mapByShop[p.offer_id] || { sizes_package: {} }).sizes_package || {}).volume}
                        center
                        readOnly
                      />
                    </Row>
                  ))}
                </Column>
              </TableCell>
            </TableLine>
          )
        })}
      </Table>
      {calculation[select] && (user.role === 'owner' || user.role === 'admin') && (
        <div style={{ marginTop: '10px' }}>
          <H2>Заказов на сумму: {numberWithSpaces(calculation[select].all.toFixed(0))}</H2>
          <H2>Комиссия: {numberWithSpaces(calculation[select].allCom.toFixed(0))}</H2>
          <H2>Закупка: {numberWithSpaces(calculation[select].allPurchase.toFixed(0))}</H2>

          <H2>Прибыль: {numberWithSpaces(calculation[select].allProfit.toFixed(0))}</H2>
          <H2>
            Маржинальность: ~{' '}
            {numberWithSpaces(Math.ceil((calculation[select].allProfit * 100) / calculation[select].allPurchase))} %
          </H2>
        </div>
      )}
      {isViewerOpen && <ImageViewer src={images} currentIndex={0} onClose={closeImageViewer} />}
    </>
  );
};

export default OzonTableOrders;
